import './App.css';
import { Routes } from 'react-router-dom';
import { PUBLISH_MODE } from './utils/functions-utils';
import NetConnection from './modules/components/common/modal/net-connection';
import { getRoutes } from './utils/get-routes-utils';
import GetWebviewMessage from 'modules/deep-linking/get-webview-message';
import { AppLoaded } from 'modules/components/webview/app-loaded';
import { mainRoutes } from 'routes';
import VersionModal from 'modules/components/common/modal/version-modal';

function App() {
  // for remove console.log in production
  if (PUBLISH_MODE.name === 'PRODUCTION') {
    console.log = function () {};
  }

  return (
    <>
      <AppLoaded />
      <GetWebviewMessage />
      <NetConnection />
      <VersionModal />
      <Routes>{getRoutes(mainRoutes)}</Routes>
    </>
  );
}

export default App;
